import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    height: 100%;
    padding: 0.5rem 0.5rem;
    cursor: pointer;

    &:hover {
        background-color: ${(props) => props.theme.rainbow.palette.brand.lighter};
    }
`;

export const IconWrapper = styled.div<{ isActive: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    filter: ${(props) => (props.isActive ? 'none' : 'grayscale(100%)')};
    opacity: ${(props) => (props.isActive ? 1 : 0.6)};

    svg {
        width: 1.75rem;
        height: 1.75rem;
    }
`;

export const TooltipContent = styled.div`
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    white-space: nowrap;
`;
